/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'
import {CorsAnywhere} from "../CorsAnywhere";
import React from 'react'

/* global WorldWind */

export default class EcmwfSurfaceCO2 extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "Surface CO2",
            service: CorsAnywhere + "http://apps.ecmwf.int/wms/&token=public",
            version: "1.3.0",
            layerNames: "composition_co2_surface",
        };

        super(cfg);

        this.urlBuilder.transparent = false;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                "© ECMWF",
                WorldWind.Color.LIGHT_GRAY);
        }
    }

    getLayerDisplayInformation() {
        return (<div>
            <p>About half of CO<sub>2</sub> greenhouse gas emitted from fuel composting remains in atmosphere and the
                other half is observed by natural lands, ocean and other reservoirs. On satellite imagery layer, in the
                biggest area in south hemisphere we can notice Amazon rainforest breathing of CO<sub>2</sub>.</p>
            <p><a href="https://www.youtube.com/watch?v=x1SgmFa0r04" target="_blank" rel="noopener noreferrer">Read more
                here.</a></p>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                <img
                    src={"https://apps.ecmwf.int/wms/?token=public&request=GetLegend&layers=composition_co2_surface&styles=sh_nipy_spectral_ch4_surface&width=350&height=50"}
                    alt={"Legend"}/>
            </div>
            <p style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'}}>
                ppmv (parts per million by volume)
            </p>
        </div>);
    }
}
